import Constants from 'constants';
import Utils from './../../../app/utils';
import { isEmpty } from 'lodash';
import {
    makeBookingNotes, prepareRis,
    prepareChildAndBedPolicyData, prepareSurchargePolicyData,
    makeCancellationArr, prepareBenefitsData
} from '../common/setReviewOrConfirmJson';
import APP from 'app';
import moment from 'moment';
import genericConnector from '../../connect/genericConnector';

const { markupAllowConfig = {}, editMarkup = true, sendFrontendSuccessEmails = false } = APP.Utils.getConfig();

const { configuration } = Constants,
    { CHECKOUT: { showHotelNumber = false } } = configuration,

    getStore = (arr) => {
        return arr.map((room) => {
            const { ti = [] } = room;
            return {
                travellerInfo: ti
            };
        });
    },

    getTotalValues = (arr, ss, omi = {}) => {
        const { sgti = {} } = omi;
        const { pah = false, vta = false } = sgti;
        let showMU = false, allowEditMarkup = editMarkup,
            totalMU = 0, totalAmount = 0,
            baseFare = 0, totalMF = 0,
            totalMFT = 0, totalTax = 0,
            totalOT = 0,
            totalSupplierTax = 0,
            totalAmendmentFee = 0,
            totalAmendmentFeeTax = 0,
            totalST = 0,
            totalTSF = 0,
            totalDS = 0,
            totalVD = 0,
            totalPF = 0,
            totalTCS = 0,
            totalRP = 0,
            totalCB = 0,
            totalGT = 0
        let isComputable = vta && !pah;
        let showGT = vta;
        arr.forEach((val) => {
            const { tfcs = {}, tafcs = {} } = val,
                { TAF: totalAdditionalFare = {} } = tafcs,
                { MU = 0, MF = 0, MFT = 0, PF = 0, DS = 0, TSF = 0, OT = 0, MNT = 0, ST = 0, CAF = 0, CAFT = 0, HAF = 0, HAFT = 0, VD = 0, TCS = 0, RP = 0, CB = 0, GT = 0 } = totalAdditionalFare,
                { TF = 0, BF = 0, TAF = 0, NF = 0, SP = 0, MF: oldMF = 0, MFT: oldMFT = 0, MU: oldMU = 0, PF: oldPF = 0, MT: oldMT = 0, TSF: oldTSF = 0, ST: oldST = 0 } = tfcs;
            if (MU !== '') {
                showMU = !Utils.isB2C();
                totalMU += parseFloat(MU + oldMU);
            }
            baseFare += parseFloat(BF + SP);
            totalAmount += parseFloat(TF);
            totalTax += (parseFloat(MF + oldMF) + parseFloat(MFT + oldMFT) +
                parseFloat(PF + oldPF) + parseFloat(OT) + parseFloat(MNT + oldMT) +
                ((MU + oldMU) === '' ? 0 : parseFloat(MU + oldMU)) + parseFloat(CAF) +
                parseFloat(CAFT) + parseFloat(HAF) + parseFloat(HAFT) +
                (isComputable ? parseFloat(GT) : 0));
            totalMF += parseFloat(MF + oldMF);
            totalMFT += parseFloat(MFT + oldMFT);
            totalPF += parseFloat(PF + oldPF);
            totalDS += parseFloat(DS);
            totalVD += parseFloat(VD);
            totalAmendmentFee += parseFloat(CAF + HAF);
            totalAmendmentFeeTax += parseFloat(CAFT + HAFT);
            totalOT += parseFloat(OT);
            totalSupplierTax += parseFloat(TSF + oldTSF) + parseFloat(ST + oldST);
            totalST += parseFloat(ST + oldST);
            totalTSF += parseFloat(TSF + oldTSF);
            totalTCS += parseFloat(TCS),
                totalRP += parseFloat(RP),
                totalCB += parseFloat(CB),
                totalGT += parseFloat(GT);
        });
        if (ss.includes('EXPEDIA') && !markupAllowConfig['EXPEDIA']) {
            allowEditMarkup = false;
        }
        return {
            showMU, totalMU, totalAmount,
            netfare: totalAmount - totalMU,
            netPrice: totalAmount - totalMU,
            baseFare, totalTax, totalMF, totalMFT,
            totalPF, allowEditMarkup, totalDS, totalVD, totalOT, totalSupplierTax, totalST, totalTSF,
            totalAmendmentFee, totalAmendmentFeeTax, totalTCS, totalRP, totalCB,
            totalGT: showGT ? totalGT : 0
        };
    },

    getContact = (deliveryInfo) => {
        const { emails = [], contacts = [] } = deliveryInfo,
            [email] = emails,
            [mobile] = contacts;

        return {
            email, mobile
        };
    },

    getGst = () => {
        return {
            gstName: '', gstNumber: '',
            gstEmail: '', gstPhone: '',
            gstAddress: ''
        };
    },

    sendEmail = (createdOn, status, bookingUserId) => {
        const user = Utils.getUserInfoFromJwt();
        const { userId = '' } = user;
        const minutes = Utils.getMinutesDiff(moment(), moment(createdOn));
        return status === 'SUCCESS' && minutes <= 5 && userId == bookingUserId && sendFrontendSuccessEmails;
    },
    sendCorpEmail = (createdOn, status, bookingUserId, icpb) => {
        const user = Utils.getUserInfoFromJwt();
        const { userId = '' } = user;
        const minutes = Utils.getMinutesDiff(moment(), moment(createdOn));
        return status === 'SUCCESS' && minutes <= 5 && userId == bookingUserId && icpb == true;
    },

    sendExtnetInvoiceEmails = (createdOn, status, bookingUserId, iopr, extEmail = '', bookingId = '') => {
        const user = Utils.getUserInfoFromJwt();
        const { userId = '' } = user;
        const minutes = Utils.getMinutesDiff(moment(), moment(createdOn));
        // genericConnector(
        //     {
        //         api: 'errorLog',
        //         content: {
        //             status, iopr, userId, bookingUserId, minutes, extEmail,
        //             errorInfo: `Booking Confirmation - ${bookingId} `,
        //             label: "Hotel"
        //         }
        //     }
        // )
        return ((status === 'SUCCESS' || status === 'ON_HOLD' || status === 'PENDING') && minutes <= 5 && userId == bookingUserId && !isEmpty(extEmail) && sendFrontendSuccessEmails);
    },

    sendTcsEmailCheck = (payload) => {
        const { createdOn, status, bookingUserId, istcsa } = payload;
        const user = Utils.getUserInfoFromJwt();
        const { userId = '' } = user;
        const minutes = Utils.getMinutesDiff(moment(), moment(createdOn));
        const sendTcsEmail = istcsa && status === 'SUCCESS' && minutes <= 5 && userId == bookingUserId
        return sendTcsEmail;
    },
    showTjcashPopup = (payload) => {
        const { totalValues = {}, createdOn = "", status = "" } = payload;
        const { totalCB = 0 } = totalValues;
        const minutes = Utils.getMinutesDiff(moment(), moment(createdOn));
        return status === 'SUCCESS' && minutes <= 5 && totalCB > 0;
    },
    refreshTokenForTjcash = (payload) => {
        const { totalValues = {}, createdOn = "", status = "" } = payload;
        const { totalCB = 0, totalRP = 0 } = totalValues;
        const minutes = Utils.getMinutesDiff(moment(), moment(createdOn));
        return status === 'SUCCESS' && minutes <= 5 && (totalCB > 0 || totalRP > 0);
    },

    prepareData = (data) => {
        const { hInfo = {}, query = {}, deliveryInfo = {}, createdOn = '', status = '', bookingUserId = '', hotelUser = {}, bookingId = '', ...rest } = data,
            { email: extEmail = "" } = hotelUser,
            { ops = [], nt = '', inst = [], ss = [], mi = {}, ad = {} } = hInfo,
            { country = {} } = ad,
            { name: countryName = '' } = country,
            { icpb = false } = mi,
            [selectedOption = {}] = ops,
            { ris = [], cnp = {}, iopr = false, ssr = [], inst: opsInst = [], ddt = '', ipr = false, omi = {} } = selectedOption,
            { itp = false, ispfar = false, istcsa = false } = omi,
            [risData = []] = ris,
            { iexb = false } = risData,
            { notes = '' } = cnp,
            storeJson = getStore(ris),
            { checkinDate = '' } = query,
            contactInfo = getContact(deliveryInfo),
            gstInfo = getGst(),
            totalValues = getTotalValues(ris, ss, omi),
            cancellationObj = makeCancellationArr(cnp, ops),
            lastCancel = { ddt },
            bookingNotes = makeBookingNotes({ ad, nt, inst, ss, selectedOption, checkinDate }, notes, ris),
            sendSuccessEmail = sendEmail(createdOn, status, bookingUserId),
            sendExtranetInvoiceEmails = sendExtnetInvoiceEmails(createdOn, status, bookingUserId, iopr, extEmail, bookingId),
            sendCorporateEmail = sendCorpEmail(createdOn, status, bookingUserId, icpb),
            childAndBedPolicy = prepareChildAndBedPolicyData(inst, iexb),
            surchargePolicy = prepareSurchargePolicyData(opsInst),
            benefits = prepareBenefitsData(opsInst),
            sendTcsEmail = sendTcsEmailCheck({ createdOn, status, bookingUserId, istcsa }),
            showTjCashPopup = showTjcashPopup({ totalValues, createdOn, status }),
            refreshTokenForTjCash = refreshTokenForTjcash({ totalValues, createdOn, status });

        return {
            ris: showHotelNumber ? prepareRis(ris) : ris,
            storeJson, hInfo,
            searchQuery: query,
            contactInfo, gstInfo,
            cancellationObj, bookingNotes,
            lastCancel, orgRis: ris,
            totalValues, sendSuccessEmail,
            sendExtranetInvoiceEmails, status, iopr, ssr,
            childAndBedPolicy, surchargePolicy,
            benefits, bookingUserId, sendCorporateEmail, sendTcsEmail,
            itp, ispfar, hotelUser, isTcsApplicable: istcsa, showTjCashPopup,
            refreshTokenForTjCash, bookingId, ...rest
        };
    },

    setConfirmJson = (data) => {
        const { itemInfos = {}, order = {}, status = {}, errors = [], retryInSecond = 0, bookingUser = {}, hotelUser = {} } = data,
            { userId = '' } = bookingUser,
            { HOTEL = {} } = itemInfos,
            finalData = { ...order, ...HOTEL, bookingStatus: status, errors, retryInSecond, bookingUserId: userId, bookingUser, hotelUser };

        return {
            type: Constants.actions.THANKYOU.GET_DATA,
            payload: prepareData(finalData)
        };
    };

export default setConfirmJson;
